import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { TypographyComponent } from 'src/components/Typography'
import styled, { css } from 'styled-components'
import EditIcon from '@mui/icons-material/Edit'
import { FormControlLabel } from '@mui/material'

export const ContainerFlex = styled('div')(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;
    width: 100%;
    justify-content: center;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 70%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const Title = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h8};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const Subtitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h6};
      line-height: ${theme.layout.lineHeight.big}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const BlueTitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h4};
      line-height: ${theme.layout.lineHeight.medium};
      color: ${theme.colors.primary.main70};
    }
  `
)

export const BlueSubtitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h3};
      line-height: ${theme.layout.lineHeight.big};
      color: ${theme.colors.primary.main70};
      letter-spacing: 0.1rem;
    }
  `
)

export const HeaderContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.gap.small};
  `
)

export const HeaderWithImageContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.medium};
    align-items: center;
    @media (max-width: ${theme.screen.small}) {
      flex-direction: column;
      text-align: center;
    }
  `
)

export const LogoImage = styled('img')(
  ({ theme }) => css`
    max-width: 160px;
    max-height: 77.08px;
  `
)

export const SectionHeader = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: ${theme.layout.margin.small};
  `
)

export const SectionTitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h6};
      line-height: ${theme.layout.lineHeight.big};
      color: ${theme.colors.primary.main};
    }
  `
)

export const SectionSubtitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h4};
      font-weight: 500;
      text-transform: uppercase;
      span {
        font-weight: 700;
      }
    }
  `
)

export const WhatsApp = styled(WhatsAppIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const Email = styled(AlternateEmailIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const Edit = styled(EditIcon)(
  ({ theme }) => css`
    font-size: ${theme.layout.iconSize.big};
    width: ${theme.layout.iconSize.big};
    height: ${theme.layout.iconSize.big};
    color: ${theme.colors.primary.main};
  `
)

export const ContainerEdit = styled('div')(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${theme.layout.gap.small};
    cursor: pointer;

    span {
      font-size: ${theme.typograph.fontsize.h3};
      color: ${theme.colors.primary.main};

      @media (max-width: ${theme.screen.medium}) {
        display: none;
      }
    }
  `
)

export const ModalBox = styled('form')(
  ({ theme }) => css`
    padding: ${theme.layout.padding.medium};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  `
)

export const Header = styled('div')(
  ({ theme }) => css`
    && {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
    }
  `
)

export const ModalTitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h8};
      font-weight: 700;
      color: ${theme.colors.primary.main};

      @media (max-width: ${theme.screen.medium}) {
        font-size: ${theme.typograph.fontsize.h4};
      }
    }
  `
)

export const ModalDescription = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
      text-align: start;
      margin: 1.6rem 0rem 3.2rem 0rem;
      width: 100%;
      font-weight: 700;
    }
  `
)

export const FormControl = styled(FormControlLabel)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    width: 100%;
  `
)

export const Typograph = styled(TypographyComponent)(
  ({ theme }) => css`
    font-size: ${theme.typograph.fontsize.h8};
    text-transform: uppercase;
  `
)

export const ModalBoxButtons = styled('div')(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: ${theme.layout.gap.medium};
    margin-top: ${theme.layout.margin.base * 6}rem;
  `
)

export const HalfWidthContainer = styled('div')(
  ({ theme }) => css`
    width: 50%;

    &.full-row-mobile {
      @media (max-width: ${theme.screen.small}) {
        width: 100%;
      }
    }
  `
)

export const CourseName = styled('span')(
  () => css`
    text-transform: uppercase;
  `
)

export const MissingFile = styled('p')(
  () => css`
    color: red;
    font-size: 1.6rem;
  `
)
